import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExtendedBaseTab } from '@common/classes/extended-base-tab';
import { DropdownAddComponent } from '@common/components/dropdown-add/dropdown-add.component';
import { OrganizationService } from '@common/services/organization.service';
import { UserService } from '@common/services/user.service';
import { marker } from '@common/translate-marker';
import { ToastService } from '@services/toast.service';
import { CommonService } from 'app/singleton-services/common.service';
import { CustomExtendedTabService } from 'app/singleton-services/custom-extended-tab.service';

@Component({
    selector: 'app-tab-email-notifications',
    templateUrl: './tab-email-notifications.component.html',
    styleUrls: ['./tab-email-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TabEmailNotificationsComponent extends ExtendedBaseTab implements OnInit {
    @Input() userId: number;
    @Input() organizationId: number;
    @Input() editMode: boolean;
    @ViewChild(DropdownAddComponent) selectedElement: DropdownAddComponent;

    emailNotifications: any[] = [];
    initialDropdownItems: any[] = [];
    dropdownItems: any[] = [];
    showEmailEventDropdown: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private toastyService: ToastService,
        private userService: UserService,
        private organizationService: OrganizationService,
        private commonService: CommonService,
        customExtendedTabService: CustomExtendedTabService
    ) {
        super(customExtendedTabService);

        // hide selector on profile page
        this.route.url.subscribe((urlSegments) => {
            if (urlSegments.length === 0) {
                this.showEmailEventDropdown = false;
            }
        });
    }

    ngOnInit() {
        this.isBusy = true;
        this.defaultPaging();
        this.commonService.getDropdownOptions('EmailEvent').subscribe({
            next: (response: any) => {
                this.initialDropdownItems = response;
                this.getData();
            }
        });
    }

    subscribeToEmail() {
        this.toggleEmailSubscription('subscribed');
    }

    unsubscribeToEmail() {
        this.toggleEmailSubscription('unsubscribed');
    }

    subscribeButtonDisabled() {
        return (
            this.emailNotifications?.filter((x) => this.selected?.includes(x.id)).every((x) => !x.active) &&
            this.selected.length > 0
        );
    }

    unsubscribeButtonDisabled() {
        return (
            this.emailNotifications?.filter((x) => this.selected?.includes(x.id)).every((x) => x.active) &&
            this.selected.length > 0
        );
    }

    private toggleEmailSubscription(operation: string) {
        const model = { ids: this.selected, operation };

        this.userService.emailSubscription(model).subscribe({
            next: () => {
                const successMessage =
                    operation === 'subscribed'
                        ? 'You have successfully subscribed to email notifications'
                        : 'You have successfully unsubscribed to email notifications';

                this.toastyService.success(successMessage);
                this.selected = [];
                this.getData();
            }
        });
    }

    private getData() {
        this.isBusy = true;
        const service = this.userId
            ? this.userService.getEmailSubscriptions(this.userId)
            : this.organizationService.getEmailSubscriptions(this.organizationId);

        service.subscribe({
            next: (response: any) => {
                this.emailNotifications = response;
                this.dropdownItems = this.processDropdownItems(
                    this.initialDropdownItems,
                    this.emailNotifications,
                    'emailEventId'
                );

                if (this.selectedElement) {
                    this.selectedElement.setData(this.dropdownItems);
                }

                this.loadItems(this.emailNotifications);
                this.isBusy = false;
            },
            error: () => {
                this.isBusy = false;
            }
        });
    }

    addEmailSubscription($event) {
        const model = {
            emailEventId: $event.dropdownValue.id,
            userId: this.userId,
            organizationId: this.organizationId
        };
        this.commonService.addEmailSubscription(model).subscribe({
            next: () => {
                this.toastyService.success(
                    this.translateService.instant(marker('Successfully added the email event for subscription.'))
                );
                $event.dropdownValue = null;
                this.getData();
            }
        });
    }
}
